<template>
    <div class="set-component">
        <div class="set-header">隐私设置</div>
        <div class="set-body">
            <el-form label-width="140px" size="small">
                <el-form-item label="好友可见范围">
                    <el-radio-group v-model="privacy.friendVisible">
                        <el-radio label="all">全部可见</el-radio>
                        <el-radio label="friend">仅好友可见</el-radio>
                        <el-radio label="self">仅自己可见</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="手机号可见性">
                    <el-radio-group v-model="privacy.phoneVisible">
                        <el-radio label="friend">好友可见</el-radio>
                        <el-radio label="self">仅自己可见</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="个性签名可见性">
                    <el-radio-group v-model="privacy.signatureVisible">
                        <el-radio label="all">全部可见</el-radio>
                        <el-radio label="friend">仅好友可见</el-radio>
                        <el-radio label="self">仅自己可见</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="动态发布权限">
                    <el-radio-group v-model="privacy.dynamicPermission">
                        <el-radio label="all">全部可见</el-radio>
                        <el-radio label="friend">仅好友可见</el-radio>
                        <el-radio label="self">仅自己可见</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <el-button type="primary" size="small" :loading="saveLoading" @click="handleSave">保存</el-button>
        </div>
    </div>
</template>

<script>
import request from '@/api/request';

export const getPrivacySetting = (userId) => request.get('/api/user/privacy/get', { params: { userId } });
export const updatePrivacySetting = (params) => request.post('/api/user/privacy/update', null, { params });

export default {
    name: 'PrivacySetting',
    data() {
        return {
            privacy: {
                friendVisible: 'all',
                phoneVisible: 'self',
                signatureVisible: 'all',
                dynamicPermission: 'all'
            },
            saveLoading: false
        };
    },
    mounted() {
        this.loadPrivacySetting();
    },
    methods: {
        getUserId() {
            const user = JSON.parse(localStorage.getItem('userInfo'));
            return user ? (user.userId || user.id) : null;
        },
        async loadPrivacySetting() {
            try {
                const userId = this.getUserId();
                if (userId) {
                    const res = await getPrivacySetting(userId);
                    if (res.data && res.data.code === 200) {
                        const data = res.data.data;
                        if (data) {
                            this.privacy = {
                                friendVisible: data.friendVisible || 'all',
                                phoneVisible: data.phoneVisible || 'self',
                                signatureVisible: data.signatureVisible || 'all',
                                dynamicPermission: data.dynamicPermission || 'all'
                            };
                        }
                    }
                }
            } catch (e) {
                console.error('获取隐私设置失败', e);
            }
        },
        async handleSave() {
            this.saveLoading = true;
            try {
                const userId = this.getUserId();
                const res = await this.$axios.post('/api/user/privacy/update', null, {
                    params: {
                        userId,
                        friendVisible: this.privacy.friendVisible,
                        phoneVisible: this.privacy.phoneVisible,
                        signatureVisible: this.privacy.signatureVisible,
                        dynamicPermission: this.privacy.dynamicPermission
                    }
                });
                if (res.data && res.data.code === 200) {
                    this.$message.success('保存成功');
                }
            } catch (e) {
                this.$message.error('保存失败');
            } finally {
                this.saveLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.set-component { background: var(--card-background); border-radius: 12px; border: 1px solid var(--border-color-lighter); }
.set-header { padding: 18px 24px; font-size: 16px; font-weight: 600; color: var(--text-color); border-bottom: 1px solid var(--border-color-lighter); }
.set-body { padding: 24px; }
</style>
